var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraphQlIcon = function SvgGraphQlIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 19 21"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GraphQLIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18.27v20.45H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#GraphQLIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.13 1.58 7.48 4.32v8.64l-7.48 4.32-7.48-4.31V5.91zM2.49 6.39v6.35l5.5-9.52zm6.64-3.48L2.8 13.89h12.68zm5.5 11.82H3.64l5.5 3.17 5.5-3.17zm1.15-1.99-5.5-9.52 5.5 3.17z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13 3.84a1.77 1.77 0 1 0 0-3.54 1.77 1.77 0 0 0 0 3.54m7.07 4.08a1.77 1.77 0 1 0 0-3.54 1.77 1.77 0 0 0 0 3.54m0 8.16a1.77 1.77 0 1 0 0-3.54 1.77 1.77 0 0 0 0 3.54m-7.07 4.07a1.77 1.77 0 1 0 0-3.54 1.77 1.77 0 0 0 0 3.54m-7.06-4.07a1.77 1.77 0 1 0 0-3.54 1.77 1.77 0 0 0 0 3.54m0-8.16a1.77 1.77 0 1 0 0-3.54 1.77 1.77 0 0 0 0 3.54",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export default SvgGraphQlIcon;